<template>
  <v-container fluid class="py-6">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <!-- Header -->
        <v-card class="mb-6" elevation="2">
          <v-card-title class="primary white--text">
            <v-icon color="white" class="mr-2">mdi-chart-box-outline</v-icon>
            Andamento da Avaliação da Gestão - Família
          </v-card-title>
          <v-card-actions class="pa-4">
            <span class="text--secondary body-2" v-if="atualizadoEm">Atualizado às {{ atualizadoEm }}</span>
            <v-spacer />
            <v-btn text color="primary" :loading="loading" @click="carregar">
              <v-icon left>mdi-refresh</v-icon>
              Atualizar
            </v-btn>
            <v-btn color="primary" :disabled="loading || !lista.length" @click="exportarPdf">
              <v-icon left>mdi-file-pdf-box</v-icon>
              Exportar PDF
            </v-btn>
          </v-card-actions>
        </v-card>

        <!-- Resumo -->
        <v-row class="mb-2">
          <v-col cols="6" md="3">
            <v-card elevation="2" class="pa-4 text-center resumo-card">
              <div class="text-h5 font-weight-bold primary--text">{{ totalInstituicoes }}</div>
              <div class="text--secondary body-2">Instituições</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card elevation="2" class="pa-4 text-center resumo-card">
              <div class="text-h5 font-weight-bold primary--text">{{ totalCredenciados }}</div>
              <div class="text--secondary body-2">Credenciados</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card elevation="2" class="pa-4 text-center resumo-card">
              <div class="text-h5 font-weight-bold primary--text">{{ totalAvaliaram }}</div>
              <div class="text--secondary body-2">Avaliaram</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card elevation="2" class="pa-4 text-center resumo-card">
              <div class="text-h5 font-weight-bold" :class="`${corPercentual(percentualGeral)}--text`">
                {{ percentualGeral.toFixed(1) }}%
              </div>
              <div class="text--secondary body-2">Percentual geral</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabela -->
        <v-card elevation="2">
          <v-card-text class="pa-4 pb-0">
            <v-text-field
              v-model="busca"
              label="Buscar instituição"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
              class="mb-4"
            ></v-text-field>
          </v-card-text>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Instituição</th>
                  <th class="text-right" style="width: 130px">Credenciados</th>
                  <th class="text-right" style="width: 110px">Avaliaram</th>
                  <th style="width: 220px">% Avaliado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="inst in listaFiltrada" :key="inst.id_instituicao">
                  <td>{{ inst.instituicao }}</td>
                  <td class="text-right">{{ inst.total_credenciados }}</td>
                  <td class="text-right">{{ inst.total_avaliaram }}</td>
                  <td>
                    <div class="d-flex align-center">
                      <v-progress-linear
                        :value="Number(inst.percentual_avaliado)"
                        :color="corPercentual(inst.percentual_avaliado)"
                        height="8"
                        rounded
                        class="mr-2"
                      ></v-progress-linear>
                      <span class="body-2" style="min-width: 48px"
                        >{{ Number(inst.percentual_avaliado).toFixed(1) }}%</span
                      >
                    </div>
                  </td>
                </tr>
                <tr v-if="!loading && !listaFiltrada.length">
                  <td colspan="4" class="text-center text--secondary py-6">Nenhuma instituição encontrada.</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-card-text v-if="loading" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">{{ snackbarText }}</v-snackbar>
  </v-container>
</template>

<script>
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import filtros from "@/libs/filters";
import AvaliacaoInstitucionalServices from "@/services/avaliacaoInstitucional/AvaliacaoInstitucionalServices";

export default {
  name: "AndamentoFamilia",
  data: () => ({
    lista: [],
    busca: "",
    loading: false,
    atualizadoEm: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
  }),
  components: {},
  filters: filtros,
  computed: {
    totalInstituicoes() {
      return this.lista.length;
    },
    totalCredenciados() {
      return this.lista.reduce((acc, i) => acc + Number(i.total_credenciados || 0), 0);
    },
    totalAvaliaram() {
      return this.lista.reduce((acc, i) => acc + Number(i.total_avaliaram || 0), 0);
    },
    percentualGeral() {
      if (!this.totalCredenciados) return 0;
      return (this.totalAvaliaram / this.totalCredenciados) * 100;
    },
    listaFiltrada() {
      let lista = this.lista;
      if (this.busca) {
        const termo = this.busca.toLowerCase();
        lista = lista.filter((i) => i.instituicao.toLowerCase().includes(termo));
      }
      return [...lista].sort((a, b) => Number(b.percentual_avaliado) - Number(a.percentual_avaliado));
    },
  },
  methods: {
    async carregar() {
      this.loading = true;
      try {
        this.lista = await AvaliacaoInstitucionalServices.andamentoAvaliacaoFamilia();
        console.log("lista", this.lista);
        this.atualizadoEm = new Date().toLocaleTimeString("pt-BR");
      } catch (e) {
        this.exibirMensagem("Erro ao carregar o andamento da avaliação.", "error");
      } finally {
        this.loading = false;
      }
    },
    corPercentual(valor) {
      const v = Number(valor);
      if (v >= 75) return "success";
      if (v >= 40) return "warning";
      return "error";
    },
    exibirMensagem(texto, cor) {
      this.snackbarText = texto;
      this.snackbarColor = cor;
      this.snackbar = true;
    },
    exportarPdf() {
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      const dataAtual = new Date().toLocaleString("pt-BR");

      doc.setFontSize(14);
      doc.text("Andamento da Avaliação Institucional - Família", 40, 40);
      doc.setFontSize(10);
      doc.text(`Emitido em ${dataAtual}`, 40, 58);

      doc.setFontSize(11);
      doc.text(
        `Instituições: ${this.totalInstituicoes}    Credenciados: ${this.totalCredenciados}    ` +
          `Avaliaram: ${this.totalAvaliaram}    Percentual geral: ${this.percentualGeral.toFixed(1)}%`,
        40,
        76,
      );

      doc.autoTable({
        startY: 92,
        head: [["Instituição", "Credenciados", "Avaliaram", "% Avaliado"]],
        body: this.listaFiltrada.map((i) => [
          i.instituicao,
          i.total_credenciados,
          i.total_avaliaram,
          `${Number(i.percentual_avaliado).toFixed(1)}%`,
        ]),
        styles: { fontSize: 9 },
        headStyles: { fillColor: [25, 118, 210] },
        margin: { left: 40, right: 40 },
      });

      doc.save(`andamento-avaliacao-familia-${Date.now()}.pdf`);
    },
  },
  mounted: function () {
    this.carregar();
  },
};
</script>

<style scoped>
.resumo-card {
  border-radius: 12px !important;
}
</style>
